import * as React from "react";
const LeftPage = (props) => (
  <svg
    width={13}
    height={21}
    viewBox="0 0 13 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.29231 10.7988L9.83834 19.6895C10.2505 20.1183 10.9187 20.1183 11.3309 19.6895L12.3276 18.6526C12.7391 18.2245 12.7399 17.5307 12.3294 17.1017L5.55649 10.0224L12.3294 2.94315C12.7399 2.51408 12.7391 1.82031 12.3276 1.39225L11.3309 0.355287C10.9187 -0.073507 10.2505 -0.073507 9.83834 0.355287L1.29235 9.24604C0.880187 9.67479 0.880187 10.37 1.29231 10.7988Z"
      fill="#BD9F3F"
    />
  </svg>
);
export default LeftPage;
